import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'poi/pdf';
const CONTEXT_BASE_HTML_PATH = 'poi/html';
const CONTEXT_SINGLE_BASE_PATH = 'poi/pdfindividual';
// #endregion

// #region Public functions
async function getPOIPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchPOIPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchPOIHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getPOIPdf,
  searchPOIPdf,
  searchPOIHtml,
};
